import {
    Box, TextField, Button, Paper, useTheme, Icon, Typography, Skeleton

} from "@mui/material"
import Grid from '@mui/material/Grid2';
import { Enviroment } from "../../enviroments";
import CarregarDropLiga from "../select/SelectLigas";
import CookieService from "../../services/autenticacao/CookieService";
import { UtilidadeService } from "../../services/api/utilidades/UtilidadesService";

export interface ILstLiga {
    codigo: number;
    label: string;
}

export interface ILstFranquiasLiga {
    codigo: number;
    label: string;
    codigoUsuario: number;
}


interface IFerramentasDaListagem {
    textoDaBusca?: string;
    mostrarInputBusca?: boolean;
    aoMudarTextoDeBusca?: (novoTexto: string) => void;
    textoBotaoNovo?: string;
    mostrarBotaoNovo?: boolean;
    aoClicarBotaoNovo?: () => void;

    mostrarBotaoVoltar?: boolean;
    mostrarBotaoVoltarCarregando?: boolean;
    aoClicarEmVoltar?: () => void;
}


export const FerramentasDaListagem: React.FC<IFerramentasDaListagem> = ({
    textoDaBusca = "",
    mostrarInputBusca = false,
    aoMudarTextoDeBusca,
    aoClicarBotaoNovo,
    textoBotaoNovo = "Novo",
    mostrarBotaoNovo = true,
    mostrarBotaoVoltar = false,
    mostrarBotaoVoltarCarregando = false,
    aoClicarEmVoltar,

}) => {
    const theme = useTheme();
    const user = CookieService.get("access_user");
    return (
        <Box gap={1}
            height={UtilidadeService.isMobile() ? user.administrador ? mostrarBotaoVoltar || mostrarInputBusca || mostrarBotaoNovo? theme.spacing(20) : theme.spacing(15):theme.spacing(5) : theme.spacing(5)}
            marginX={1} //somente nas laterais
            padding={1}
            paddingX={2} //somente nas laterais
            display="flex"
            alignItems="center"
            component={Paper}
        >
            <Grid container size={{xs:12, sm:12}} display="flex" padding={UtilidadeService.isMobile() ? 1 : 0} direction={"row"}>
                <Grid size={{xs:12, sm:6}} >
                    <Box flex={1} display={user.pagamentoConcluido ? "flex" : "none"} justifyContent="start"  >
                        <CarregarDropLiga redirecionar={true} />
                    </Box>
                </Grid>
                {mostrarInputBusca && (
                    <Grid  size={{xs:3, sm:2}}  display={"flex"} justifyContent="center" alignSelf={"center"} paddingTop={UtilidadeService.isMobile() ? 1 :"auto"}>
                        <TextField
                            size="small"
                            value={textoDaBusca}
                            onChange={(e) => aoMudarTextoDeBusca?.(e.target.value)}
                            placeholder={Enviroment.INPUT_DE_BUSCA}

                        />
                    </Grid>
                )}
                {(mostrarBotaoVoltar && !mostrarBotaoVoltarCarregando) && (
                    <Grid  size={{xs:6, sm:2}} display={"flex"} justifyContent="center" alignSelf={"center"} paddingTop={UtilidadeService.isMobile() ? 2 :"auto"}>
                        <Button
                            color="info"
                            variant="outlined"
                            disableElevation
                            onClick={aoClicarEmVoltar}
                            startIcon={<Icon>arrow_back</Icon>}
                        >
                            <Typography variant="button" whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
                                Voltar
                            </Typography>
                        </Button>
                    </Grid>
                )}
                {mostrarBotaoVoltarCarregando && (<Skeleton width={125} height={60} />)}
                {mostrarBotaoNovo && (
                    <Grid  size={{xs:6, sm:2}}
                        display={user.pagamentoConcluido ? "flex" : "none"}
                        justifyContent={"end"}
                        paddingTop={UtilidadeService.isMobile() ? 2 :"auto"}
                        style={{
                            display: "flex",
                            justifyContent: "end",
                            alignItems: "end",
                            height: "10%",
                            alignSelf: "center",
                            
                        }}>
                        <Button
                            color="primary"
                            variant="contained"
                            disableElevation
                            onClick={aoClicarBotaoNovo}
                            endIcon={<Icon>add</Icon>}
                        >
                            {textoBotaoNovo}
                        </Button>
                    </Grid>
                )}
            </Grid>
        </Box>
    )
}